import { BaseRouteService } from "./BaseRouteService";

export interface LevelProgressResponse {
    completed: string[];
    unlocked: string[];
}

export class GameLevelRouteService extends BaseRouteService {
    public async getLevels(): Promise<LevelProgressResponse> {
        return this.getJsonApi<LevelProgressResponse>("game/levels");
    }

    public async selectActiveLevel(levelAlias: string): Promise<void> {
        await this.postJsonApi<unknown, { level: string }>("game/select-active-level", { level: levelAlias });
    }
}
